import antdEn from 'antd/lib/locale-provider/en_US';
import { flattenMessages } from 'lng-provider';
import enMessages from '../locales/en-US.json';
import constEnMessages from "../locales/const-EN.json";

const EnLang = {
  messages: {
    ...flattenMessages(enMessages),
    ...flattenMessages(constEnMessages),
  },
  antd: antdEn,
  locale: 'en-US'
};
export default EnLang;
